<template>
    <div class="home-jg">
      <div v-if="yhsfId == '11'">
        <div class="box-top">
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :lg="12" v-for="(item,index) in tjList2" :key="index">
              <div class="box-count" style="padding: 5px 0 15px;">
                <h3>{{item.title}}</h3>
                <div class="num-btm">
                  <img class="rt-img" :src="item.src"/>
                  <p>
                    <span><i>{{item.tip1}}</i><b>{{item.num1}}</b></span>
                    <span><i>{{item.tip2}}</i><b>{{item.num2}}</b></span>
                    <span><i>{{item.tip3}}</i><b>{{item.num3}}</b></span>
                  </p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-else>
        <template v-if="shi == '新乡市'">
          <div class="box-top">
            <el-row :gutter="16">
              <el-col :xs="24" :sm="24" :lg="24" v-for="(item,index) in tjList" :key="index">
                <div v-if="index == 0" class="box-count">
                  <h3>{{item.title}}</h3>
                  <div class="num-btm">
                    <img class="rt-img" :src="item.src"/>
                    <p>
                      <span><i>{{item.tip1}}</i><b>{{item.num1}}</b></span>
                      <span><i>{{item.tip2}}</i><b>{{item.num2}}</b></span>
                      <span><i>{{item.tip3}}</i><b>{{item.num3}}</b></span>
                    </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row :gutter="14">
            <el-col :xs="24" :sm="12" :lg="12" v-for="(item,index) in List" :key="index">
              <div v-if="index == 0 || index == 1" class="box-card"> 
                <div class="lft-text">
                  <p>{{item.title}}</p>
                  <label>{{item.num}}</label>
                </div>
                <img class="right-img" :src="item.src"/>
              </div>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <div class="box-top">
            <el-row :gutter="16">
              <el-col :xs="24" :sm="8" :lg="8" v-for="(item,index) in tjList" :key="index">
                <div class="box-count">
                  <h3>{{item.title}}</h3>
                  <div class="num-btm">
                    <img class="rt-img" :src="item.src"/>
                    <p>
                      <span><i>{{item.tip1}}</i><b>{{item.num1}}</b></span>
                      <span><i>{{item.tip2}}</i><b>{{item.num2}}</b></span>
                      <span><i>{{item.tip3}}</i><b>{{item.num3}}</b></span>
                    </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row :gutter="14">
            <el-col :xs="24" :sm="4" :lg="4" v-for="(item,index) in List" :key="index">
              <div class="box-card"> 
                <div class="lft-text">
                  <p>{{item.title}}</p>
                  <label>{{item.num}}</label>
                </div>
                <img class="right-img" :src="item.src"/>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="14">
              <el-col :xs="24" :sm="24" :lg="12">
                  <div class="index-box">
                  <div class="title">
                    <span>月度案件数量统计</span>
                    <div class="btns">
                      <a :class="year == year1 ? 'active' :''" @click="getYear(year1)">{{year1}}年</a>
                      <a :class="year == year2 ? 'active' :''" @click="getYear(year2)">{{year2}}年</a>
                    </div>
                  </div>
                  <div class="top-content" style="height:265px;">
                    <bar-echart :year="this.year" />
                  </div>
                  </div>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="12">
                  <div class="index-box">
                  <div class="title"><span>案件来源分类统计</span></div>
                  <div class="top-content" style="height:265px;">
                    <pie-echart />
                  </div>
                  </div>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="12">
                  <div class="index-box">
                  <div class="title"><span>各专业类别案件评分统计</span></div>
                  <div class="top-content" style="height:265px;">
                    <bar-echart2 />
                  </div>
                  </div>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="6">
                  <div class="index-box">
                  <div class="title"><span>交罚款占比</span></div>
                  <div class="top-content" style="height:265px;">
                    <pie-echart2 />
                  </div>
                  </div>
              </el-col>
              <el-col :xs="24" :sm="24" :lg="6">
                  <div class="index-box">
                  <div class="title"><span>各专业案件数量占比</span></div>
                  <div class="top-content" style="height:245px; padding:20px 20px 0;">
                    <el-row :gutter="10">
                      <el-col :xs="24" :sm="24" :lg="12">
                        <el-table :data="mxList.slice(0,6)" stripe style="width:100%;">
                          <el-table-column label="专业" prop="title" max-width="34%" width="40" />
                          <el-table-column label="数量" align="center" prop="num" max-width="33%" width="40"  />
                          <el-table-column label="占比" align="center" prop="pre" max-width="33%" />
                        </el-table>
                      </el-col>
                      <el-col :xs="24" :sm="24" :lg="12">
                        <el-table :data="mxList.slice(6,12)" stripe style="width:100%;">
                          <el-table-column label="专业" prop="title" max-width="34%" width="40" />
                          <el-table-column label="数量" align="center" prop="num" max-width="33%" width="40"  />
                          <el-table-column label="占比" align="center" prop="pre" max-width="33%" />
                        </el-table>
                      </el-col>
                    </el-row>
                  </div>
                  </div>
              </el-col>
          </el-row>
        </template>
      </div>
    </div>
  </template>
  
<script>
import BarEchart from '../components/index/BarEchart.vue'
import BarEchart2 from '../components/index/BarEchart2.vue'
import PieEchart from '../components/index/PieEchart.vue'
import PieEchart2 from '../components/index/PieEchart2.vue'
import axios from 'axios'
import qs from 'qs'
    export default {
      name: 'Index',
      components: {
        BarEchart,
        BarEchart2,
        PieEchart,
        PieEchart2
      },
      data(){
        return {
          tjList:[
            {title:'案件数量统计',src:require('../assets/images/index-tj1.png'),tip1:'总数量',num1:0,tip2:'进行中',num2:0,tip3:'已完成',num3:0},
            {title:'电子档案上传省平台情况',src:require('../assets/images/index-tj2.png'),tip1:'已上传',num1:0,tip2:'未上传',num2:0,tip3:'上传率',num3:'0%'},
            {title:'PDF完整卷宗统计',src:require('../assets/images/index-tj3.png'),tip1:'已上传',num1:0,tip2:'未上传',num2:0,tip3:'上传率',num3:'0%'},
          ],
          tjList2:[
            {title:'任务数量统计',src:require('../assets/images/index-tj1.png'),tip1:'总数量',num1:0,tip2:'已发布',num2:0,tip3:'待发布',num3:0},
            {title:'审核情况统计',src:require('../assets/images/index-tj2.png'),tip1:'待审核',num1:0,tip2:'审核通过',num2:0,tip3:'审核驳回',num3:'0'},
          ],
          List:[
            {title:'案件评查数',src:require('../assets/images/index-ic1.png'),num:0},
            {title:'案件平均分',src:require('../assets/images/index-ic2.png'),num:0},
            {title:'案后评查数',src:require('../assets/images/index-ic1.png'),num:0},
            {title:'案后评查平均分',src:require('../assets/images/index-ic2.png'),num:0},
            {title:'案中评查数',src:require('../assets/images/index-ic1.png'),num:0},
            {title:'案中评查平均分',src:require('../assets/images/index-ic2.png'),num:0},
          ],
          year1:null,
          year2:null,
          year:null,
          mxList:[
              {title:'公',num:68,pre:'7%'},
              {title:'水',num:56,pre:'6%'},
              {title:'学',num:32,pre:'4%'},
              {title:'医',num:16,pre:'2%'},
              {title:'职',num:123,pre:'13%'},
              {title:'传',num:273,pre:'25%'},
              {title:'放',num:68,pre:'7%'},
              {title:'血液',num:56,pre:'6%'},
              {title:'消',num:32,pre:'4%'},
              {title:'计生',num:16,pre:'2%'},
              {title:'爱',num:123,pre:'13%'}
          ],
          total:0,
          cmid:'',
          yhsfId:'',
          baseUrl:'',
          shi:''
        }
      },
      created() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.shi = user.shi
        console.log(this.shi);
        this.yhsfId = user.yhsfId
        this.baseUrl = user.baseUrl
        let currentDate = new Date();
        // 获取当前年份
        this.year2 = currentDate.getFullYear();
        this.year = currentDate.getFullYear(); 
        this.year1 = Number(this.year2) - 1;
        if(this.yhsfId == '11'){
          this.getList2(); 
        }else{
          this.getList(); 
        }
      },
      methods: {
        getList2(){
          this.tjList2 = [
            {title:'任务数量统计',src:require('../assets/images/index-tj1.png'),tip1:'总数量',num1:0,tip2:'已发布',num2:0,tip3:'待发布',num3:0},
            {title:'审核情况统计',src:require('../assets/images/index-tj2.png'),tip1:'待审核',num1:0,tip2:'审核通过',num2:0,tip3:'审核驳回',num3:'0'},
          ]
          axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/system/release/homePageData`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {}
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.tjList2[0].num1 = response.data.data.totalTasks
                    this.tjList2[0].num2 = response.data.data.publishedTasks
                    this.tjList2[0].num3 = response.data.data.pendingTasks
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getYear(val){
          this.year = val
          console.log(this.year)
        },
        getList() {
          // this.List = []sumanjian
          axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/login/shouyeshujuzhanshi`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                  cmid:this.cmid,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    let obj = response.data.data
                    if(obj){
                      this.tjList[0].num1 = obj.sumanjian
                      this.tjList[0].num2 = obj.jxzanjian
                      this.tjList[0].num3 = obj.ywcanj
                      this.tjList[1].num1 = obj.sptysc
                      this.tjList[1].num2 = obj.sptwsc
                      this.tjList[1].num3 = obj.sptscl == '0' ? '0%' : Number(obj.sptscl).toFixed(2)+'%'
                      this.tjList[2].num1 = obj.pdfysc
                      this.tjList[2].num2 = obj.pdfwsc
                      this.tjList[2].num3 = obj.pdfscl == '0' ? '0%' : Number(obj.pdfscl).toFixed(2)+'%'
                      this.List[0].num = obj.ajpcs
                      this.List[1].num = obj.ajpjf
                      this.List[2].num = obj.ahpcs
                      this.List[3].num = obj.ahpjf
                      this.List[4].num = obj.azpcs
                      this.List[5].num = obj.azpjf
                    }
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
      }
    }
</script>
  
  <style scoped>
  ul,ul li{ margin: 0; padding: 0; list-style: none;}
  p{ margin: 0; padding: 0;}
  .box-top{ background: #fff;border-radius: 8px; padding: 16px; margin-bottom: 14px;}
  .box-count{width: 100%; height: 128px; background: url(../assets/images/tj-bg.png) no-repeat center center; background-size:100% 100% ;}
  .box-count h3{padding:20px 20px 0;font-weight: bold;font-size: 16px;color: #000000;}
  .num-btm{width: 100%;}
  .num-btm img{float: left; margin:0 24px; width: 75px;}
  .num-btm p{ float: right; width: calc(100% - 123px); margin-top:16px;}
  .num-btm p span{float: left; width: 33.33%; text-align: center;}
  .num-btm p span i{width: 100%; display: block;font-style: normal; font-size: 14px;color: #808080;}
  .num-btm p span b{width: 100%;display: block;font-family: 'shuzi2';font-size: 24px;color: #000000; margin-top:4px;}
  .box-card{background: #fff;border-radius: 8px;padding:18px 18px 18px 20px; height:44px; margin-bottom: 14px;}
  .lft-text{float: left;}
  .lft-text p{font-size: 16px;color: #000000;margin-bottom: 3px;}
  .lft-text label{font-family: 'shuzi2';font-weight: bold;font-size: 20px;color: #000000;}
  .right-img{float: right; width: 44px;height: 44px; background: rgba(0, 114, 255, 0.2);}

  .index-box{
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    position: relative;
  }
  .btns{ position: absolute; right: 20px;top:15px;overflow: hidden;}
  .btns a{width: 78px; text-align: center; float: left; line-height: 28px; border: 1px solid #CCCCCC;font-size: 12px;color: #808080;cursor: pointer;}
  .btns a:nth-child(1){ border-top-left-radius: 2px; border-bottom-left-radius: 2px; border-right: solid 1px #fff;}
  .btns a:nth-child(2){ border-top-right-radius: 2px; border-bottom-right-radius: 2px; border-left: solid 1px #fff;}
  .btns a.active{background: #3A96F5; border:1px solid #3A96F5; color: #fff;}
  .title { width: 100%; padding: 20px 20px 0;height: 20px;margin: 0;text-align: left; overflow: hidden;}
  .title span{ width: 100%; padding: 0px 0 0 10px; line-height: 20px; color: #333; font-size: 16px;font-weight: bold;margin: 0; border-left: solid #3B73D7 6px;}
  
  .top-content >>> .el-table--border::after,.top-content >>>  .el-table--group::after,.top-content >>>  .el-table::before{background: #fff;}
  .top-content >>> .el-table{color:#000;}
  .top-content >>> .el-table td, .top-content >>>  .el-table th{padding:4px 0;}
  .top-content >>>  .el-table th{background: #BADDFF;}
  .top-content >>> .el-table .cell{padding:0 4px;}
  .top-content >>>  .el-table .el-table__body,.top-content >>>  .el-table .el-table__footer,.top-content >>>  .el-table .el-table__header{ width: 100% !important;}
  </style>
  